/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 **************************************************************************/
/**
 * TODO - pull in LinkStatus from SAM.js (wait until SAM.js converts to enums)
 */
export var LinkStatus;
(function (LinkStatus) {
    LinkStatus["UpToDate"] = "UpToDate";
    LinkStatus["OutOfDate"] = "OutOfDate";
    LinkStatus["MetadataOutOfDate"] = "MetadataOutOfDate";
    LinkStatus["Restricted"] = "Restricted";
    LinkStatus["Discarded"] = "Discarded";
    LinkStatus["Broken"] = "Broken";
})(LinkStatus || (LinkStatus = {}));
export var Role;
(function (Role) {
    Role["Edit"] = "Edit";
    Role["View"] = "View";
    Role["None"] = "None";
})(Role || (Role = {}));
/**
 * Message types used in CCLibrariesInterface
 */
export var MessageType;
(function (MessageType) {
    MessageType["assets"] = "ccac.dap.in.notify.assets";
    MessageType["update"] = "ccac.dap.out.notify.update";
    MessageType["config"] = "ccac.dap.in.notify.config";
    MessageType["showShare"] = "ccac.dap.out.notify.showShare";
    MessageType["requestAction"] = "ccac.libraries.out.request.action";
    MessageType["requestUpdate"] = "ccac.libraries.in.request.update";
    MessageType["applyElements"] = "ccac.libraries.out.request.apply";
})(MessageType || (MessageType = {}));
/**
 * Action types for 'ccac.libraries.out.request.action' message type
 */
export var RequestActionTypes;
(function (RequestActionTypes) {
    RequestActionTypes["openPicker"] = "openPicker";
    RequestActionTypes["openShareSheet"] = "openShareSheet";
    RequestActionTypes["openPreview"] = "openPreview";
})(RequestActionTypes || (RequestActionTypes = {}));
